export const socialMediaInfo = {
    linkedin: {
        title: 'Linkedin',
        url: 'https://www.linkedin.com/in/vivian-yang-uk/',
    },
    github: {
        title: 'Github',
        url: 'https://github.com/viboloveyou12',
    },
    email: {
        title: 'Email',
        url: 'mailto:yangvi0158@gmail.com',
    },
    behance: {
        title: 'Behance',
        url: 'https://www.behance.net/viviyang',
    },
    medium: {
        title: 'Medium',
        url: 'https://viboloveyou12.medium.com/'
    }
};